import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { OrgLocalDentistNotifications } from 'models/organization';

type LocalDentistNotificationSettingTableProps = {
    localDentistEmailNotifications: OrgLocalDentistNotifications;
    handleLocalDentistEmailNotifications: (event: React.ChangeEvent<HTMLInputElement>) => void;
};
const LocalDentistNotificationSettingTable: FC<LocalDentistNotificationSettingTableProps> = ({
    localDentistEmailNotifications,
    handleLocalDentistEmailNotifications,
}) => {
    const { t: translate } = useTranslation(['lab-settings']);

    return (
        <Box mb={4}>
            <Typography variant="h3">{translate('lab-settings:LOCAL_DENTIST_NOTIFICATIONS')}</Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width="60%">{translate('lab-settings:NOTIFICATION')}</TableCell>

                            <TableCell>{translate('common:EMAIL')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_RECIEVED_BY_LAB')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={localDentistEmailNotifications.orderRecievedByLab}
                                    onChange={handleLocalDentistEmailNotifications}
                                    name="orderRecievedByLab"
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_SENT_BY_LAB')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={localDentistEmailNotifications.orderSentByLab}
                                    onChange={handleLocalDentistEmailNotifications}
                                    name="orderSentByLab"
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default LocalDentistNotificationSettingTable;
